import styled from 'styled-components';
import { Box } from '@components/Box';
import { CTALink } from '@components/CTALink';
import { CloudImage } from '@components/CloudImage';
import { Flex } from '@components/Flex';
import { JoykitIcon } from '@components/JoykitIcon';
import { Text } from '@components/typography';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { themeColor, themeMediaQuery, themeSpace, themeVariant } from '@utils/styledTheme.util';
import { MediumTextStyles } from '@components/typography/interVariants';

const WRAPPER_MARGIN = 88;
const TITLE_WIDTH = 549;
const TITLE_WIDTH_SM = 350;
const TITLE_WIDTH_MOBILE = 250;
const ICON_SIZE = 28;
const IMAGE_MIN_HEIGHT = 300;

export const WrapperDiv = styled(Flex)`
  margin: ${WRAPPER_MARGIN}px;
  gap: ${themeSpace(9)};
  width: calc(100% - 176px);
  flex-direction: column;
  align-items: center;
  ${themeMediaQuery('below_sm')} {
    margin: ${themeSpace(10)} ${themeSpace(6)} ${themeSpace(8)};
    width: calc(100% - ${themeSpace(9)});
    gap: ${themeSpace(8)};
  }
`;

export const StyledText = styled(Text)`
  text-align: center;
  ${themeMediaQuery('below_sm')} {
    max-width: ${TITLE_WIDTH_MOBILE}px;
    ${themeVariant('sectionEyeBrow24')};
  }
  ${themeMediaQuery('sm')} {
    color: ${themeColor('neutra5')};
    max-width: ${TITLE_WIDTH_SM}px;
  }
  ${themeMediaQuery('lg')} {
    max-width: ${TITLE_WIDTH}px;
  }
`;

export const Container = styled(Flex)`
  column-gap: ${themeSpace(8)};
  row-gap: ${themeSpace(9)};
  flex-wrap: wrap;
  ${themeMediaQuery('below_sm')} {
    row-gap: ${themeSpace(8)};
  }
`;

export const FeatureLink = styled(CTALink)`
  align-items: flex-start;
  justify-content: center;
  width: calc((100% - ${themeSpace(8)}) / 2);
  ${themeMediaQuery('below_sm')} {
    width: 100%;
  }

  span {
    width: 100%;
  }
`;

export const FeatureSpan = styled.span`
  width: 100%;
  display: flex;
  gap: ${themeSpace(6)};
  flex-direction: column;
  justify-content: space-around;
  align-items: start;
  white-space: normal;
`;

export const MobilePhoto = styled(CloudImage)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
    min-height: ${IMAGE_MIN_HEIGHT}px;
  }
`;

export const DesktopPhoto = styled(CloudImage)`
  display: block;
  min-height: ${IMAGE_MIN_HEIGHT}px;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const FeatureDetails = styled(Flex)`
  flex-direction: column;
  gap: 0;
  align-items: start;
`;

export const Divider = styled(Box)`
  width: 100%;
  height: 1px;
  background-color: ${themeColor('mono4')};
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const FeaturePhoto = styled.span`
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: ${themeSpace(3)};
`;

export const FeatureTitle = styled(Text)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  white-space: normal;
  line-height: 38px;
  ${themeMediaQuery('sm')} {
    line-height: ${themeSpace(9)};
  }
`;

export const Description = styled(Text)`
  max-width: 95%;
  ${MediumTextStyles};
`;

export const Icon = styled(JoykitIcon)`
  margin-left: ${themeSpace(5)};
  ${themeMediaQuery('lg')} {
    height: ${ICON_SIZE}px;
    width: ${ICON_SIZE}px;
  }
`;

export const FeatureImage = styled.div<{ src: string }>`
  background: ${themeColor('warmGray1')} url(${({ src }) => cloudAssetUrl(src)});
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  left: 0;
`;
